import { ParagraphLG, ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { CheckInputButton } from '../../components/CheckInputButton'
import { Page } from '../../components/Page'
import { PageHeading } from '../../components/PageHeading'
import {
  TorchApplicationStatus,
  TorchApplicationTypes,
  useTorchApplication,
} from '../../components/TorchApplicationContext'
import { useDelayedSelection } from '../../components/useDelayedSelection'
import { TorchApplicationTypeIcon } from './TorchApplicationTypeIcon'
import { filterDraftTorchApplications, useTorchApplicationType } from './torchApplicationHelpers'
import { ExistingUserStep } from './types'

export const ContinueDraft = () => {
  const { t } = useTranslate('guild-create')
  const { torchApplications, setTorchApplication, setPageStep } = useTorchApplication()
  const getTorchApplicationType = useTorchApplicationType()

  const draftApplications = filterDraftTorchApplications(torchApplications)
  const [selection, onClick] = useDelayedSelection((id) => {
    const application = draftApplications.find((appl) => appl?.id === id)
    const isFullType = application?.type === TorchApplicationTypes.FullFilm
    setTorchApplication({ id, step: !isFullType ? ExistingUserStep.Type : undefined, page: isFullType ? 2 : undefined })
  })

  const friendlyStatus: Record<TorchApplicationStatus, string> = {
    [TorchApplicationStatus.Draft]: t('statusDraft', 'Draft'),
    [TorchApplicationStatus.Incomplete]: t('incomplete', 'Incomplete'),
    [TorchApplicationStatus.PendingReview]: t('statusInReview', 'In Review'),
    [TorchApplicationStatus.Rejected]: t('statusRejected', 'Rejected'),
    [TorchApplicationStatus.Approved]: t('approved', 'Approved'),
    [TorchApplicationStatus.InReview]: t('statusInReview', 'In Review'),
  }

  return (
    <Page onBack={() => setPageStep(0)}>
      <PageHeading>{t('whatProjectWouldYouLikeToModify', 'What project would you like to modify?')}</PageHeading>

      {draftApplications.map((appl) => {
        if (!appl) return null
        return (
          <CheckInputButton
            key={appl.id}
            name={appl.id}
            selected={selection === appl.id}
            onClick={onClick}
            className="!w-5/6 px-3 lg:!w-2/3"
          >
            <div className="flex w-full flex-row items-center gap-4">
              <TorchApplicationTypeIcon type={appl.type as TorchApplicationTypes} size={36} color="core-gray-950" />
              <div className="flex flex-col items-start">
                <ParagraphLG weight="semibold" className="text-left text-sm lg:text-lg">
                  {appl.data?.title ??
                    `${t('unnamedProject', 'Unnamed Project')} (${getTorchApplicationType(
                      appl?.type ? (appl.type as TorchApplicationTypes) : null,
                    )})`}
                </ParagraphLG>
                <ParagraphSM color="core-gray-500">
                  {appl.type === TorchApplicationTypes.FullFilm && t('fullLengthFilm', 'Full Length Film') + ' - '}
                  {appl.data?.isResubmission ? (
                    <span className="text-oxide">{t('resubmission', 'Resubmission')}</span>
                  ) : (
                    friendlyStatus[appl.status as TorchApplicationStatus]
                  )}
                </ParagraphSM>
              </div>
            </div>
          </CheckInputButton>
        )
      })}
    </Page>
  )
}
